
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { postsApi } from '../api/posts.api';
import type { ListParams, UpdatePostInput } from '../types';

export const usePostsQuery = (params?: ListParams) => useQuery({ queryKey: ['blog-posts', params], queryFn: () => postsApi.fetchPosts(params) });
export const usePostQuery = (id: string) => useQuery({ queryKey: ['blog-post', id], queryFn: () => postsApi.fetchPost(id), enabled: !!id });
export const useCreatePost = () => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: postsApi.createPost, onSuccess: () => qc.invalidateQueries({ queryKey: ['blog-posts'] }) });
};
export const useUpdatePost = (id: string) => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (data: UpdatePostInput) => postsApi.updatePost(id, data), onSuccess: () => { qc.invalidateQueries({ queryKey: ['blog-posts'] }); qc.invalidateQueries({ queryKey: ['blog-post', id] }); } });
};
export const useDeletePost = () => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: postsApi.deletePost, onSuccess: () => qc.invalidateQueries({ queryKey: ['blog-posts'] }) });
};
export const usePublishPost = () => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: postsApi.publishPost, onSuccess: () => qc.invalidateQueries({ queryKey: ['blog-posts'] }) });
};
export const useSchedulePost = () => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: ({ id, date }: { id: string, date: string }) => postsApi.schedulePost(id, date), onSuccess: () => qc.invalidateQueries({ queryKey: ['blog-posts'] }) });
};
export const useUnpublishPost = () => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: postsApi.unpublishPost, onSuccess: () => qc.invalidateQueries({ queryKey: ['blog-posts'] }) });
};
export const useDuplicatePost = () => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: postsApi.duplicatePost, onSuccess: () => qc.invalidateQueries({ queryKey: ['blog-posts'] }) });
};
